/**
 * `locations` — les lieux (base galerie, 4.1).
 *
 * Une localisation est une référence, jamais un texte libre (4.2) : « Réserve,
 * tiroir 3 » doit rester filtrable, et le mode foire doit pouvoir lister ce qui
 * est sur le stand.
 */
import { z } from 'zod';
import { adresseSchema, CHAMPS_DOCUMENT, idSchema, withAudit } from './commun.js';
export const TYPES_LIEU = ['interne', 'externe', 'foire', 'client'];
export const typeLieuSchema = z.enum(TYPES_LIEU);
export const locationSchema = withAudit(z.object({
    _id: idSchema,
    nom: z.string().min(1),
    type: typeLieuSchema,
    adresse: adresseSchema.optional(),
    contactId: idSchema.optional(),
    notes: z.string().optional(),
    actif: z.boolean().default(true),
}));
export const locationCreationSchema = locationSchema.omit(CHAMPS_DOCUMENT);
export const locationMiseAJourSchema = locationCreationSchema.partial();
//# sourceMappingURL=locations.js.map